import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash-es';
import { Container } from 'reactstrap';
import { Link } from 'site-modules/shared/components/link/link';
import { Image } from 'site-modules/shared/components/image/image';
import { getPriceStringV2 } from 'site-modules/shared/utils/price-utils';
import { DEFAULT_WIDTH, getPhotoConfig } from 'site-modules/shared/utils/inventory-image-utils';
import { getNoVehicleImageToDisplay } from 'site-modules/shared/utils/get-no-vehicle-image-to-display';
import { isCpo } from 'site-modules/shared/utils/inventory-utils/is-cpo';
import { InventoryEntities } from 'client/data/models/inventory';
import { VdpBackBtn } from 'site-modules/financing/components/shared/vdp-back-btn/vdp-back-btn';

function FinancingVehicleInfoUI({
  isMobile = false,
  isLoadingFeedbackScreen = false,
  vdpLink = '',
  vehicle = {},
  vin = '',
}) {
  const { make, model, year, trim, bodyType } = get(vehicle, 'vehicleInfo.styleInfo', {});
  const msrp = get(vehicle, 'prices.advertisedPrice');
  const isCpoType = isCpo(vehicle.type);

  const { photoUrls } = getPhotoConfig(vehicle, DEFAULT_WIDTH, null);
  const photoUrl = photoUrls[0];
  const defaultPhoto = getNoVehicleImageToDisplay(bodyType);

  const price = !!msrp && (
    <div className={classNames('fw-bold', { 'heading-4': !isMobile })}>{getPriceStringV2(msrp)}</div>
  );

  const vehicleName = (
    <div>
      {isCpoType ? 'Certified ' : ''}
      {year} {make} {model} {trim}
    </div>
  );

  return (
    <div
      className="top-bar text-gray-darker py-0_5 ps-1 pe-0_5 ps-md-1_5 pe-md-1_5"
      data-tracking-parent="financing-vehicle_info"
    >
      <Container className="d-flex justify-content-between align-items-center px-0">
        <div>
          {isMobile && price}
          {!isLoadingFeedbackScreen && <VdpBackBtn isMobile={isMobile} vdpLink={vdpLink} vehicle={vehicle} />}
          {isLoadingFeedbackScreen && isMobile && vehicleName}
        </div>

        <div className="d-flex align-items-center">
          {!isMobile && (
            <div className="text-end me-1">
              {price}
              {vehicleName}
            </div>
          )}

          <Link
            to={vdpLink}
            rel="nofollow"
            aria-disabled={false}
            tabIndex={0}
            target="_blank"
            className="vehicle-img rounded d-block"
          >
            <Image
              className="rounded"
              imageId={photoUrl}
              alt={vin ? `${make} ${model} with VIN: ${vin}` : `${year} ${make} ${model}`}
              errorImage={defaultPhoto}
              source={photoUrl ? 'media' : 'static'}
              width={106}
              height={64}
              lazy
            />
          </Link>
        </div>
      </Container>
    </div>
  );
}

FinancingVehicleInfoUI.propTypes = {
  isMobile: PropTypes.bool,
  isLoadingFeedbackScreen: PropTypes.bool,
  vdpLink: PropTypes.string,
  vin: PropTypes.string,
  vehicle: InventoryEntities.InventoryVin,
};

export const FinancingVehicleInfo = React.memo(FinancingVehicleInfoUI);
